module.exports = __webpack_public_path__ + "img/section-4-m.286c009.webp";